import { getUserCurrentDate, getUserYesterdayDate } from "./getUserCurrentDate";

// ----- Helpers -----

function getLocalStorageValue(key) {
    const value = localStorage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        localStorage.removeItem(key);
        return null;
    }
}

function setLocalStorageValue(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

// ----- Default Shape -----
// Ensures that storage NEVER has {} where arrays/objects should exist.
const defaultSnakeInfo = {
    startDate: null,
    consecutiveWins: 0,
    lastWin: null,
    lastDayPlayed: null,
    strikes: [],
    gameStatus: null,
    head: {},
    tail: {},
    playCount: 0,
    blocksFwd: [],
    blocksBck: [],
    puzzleInfo: {},
    ribbons: null,   // future feature, stays harmless here
    tutorialSeen: false,
};

// ----- Public API -----

export function checkCurrentMemory() {
    const saved = getLocalStorageValue("snake_info") || {};
    // Merge saved values on top of defaults so nothing becomes {} or undefined
    return { ...defaultSnakeInfo, ...saved };
}

export function setMemory(update = {}) {
    const prev = checkCurrentMemory();
    const next = { ...prev, ...update }; // Safe merge
    setLocalStorageValue("snake_info", next);
    return next;
}

export function resetSnakeDay() {
    const yesterday = getUserYesterdayDate();
    const memory = checkCurrentMemory();
    const today = getUserCurrentDate();

    const resetState = {
        startDate: today,
        lastDayPlayed: today,
        strikes: [],
        gameStatus: "in progress",
        head: {},
        tail: {},
        blocksFwd: [],
        blocksBck: [],
        puzzleInfo: {},
        consecutiveWins: memory.lastWin !== yesterday ? 0 : memory.consecutiveWins,
    };

    setMemory(resetState);
}
